<template>
    <vx-card title="Служебные параметры машинного обучения NATIVE" id="loader">
        <div class="vx-row mb-2">
            <div class="vx-col w-1/2">
                <div class="mt-1">
                    <vs-input
                        label="Количество дней для отсеивания."
                        v-model="form.mlAgeDayFilter"
                        class="mt-1 w-full"
                        type="number"
                        min="0"
                        :danger="!!errors.mlAgeDayFilter"
                        :danger-text="errors.mlAgeDayFilter"
                    />
                </div>
            </div>
            <div class="vx-col w-1/2">
                <div class="mt-1">
                    <vs-input
                        label="Минимальный процент показов для объявлений старше age_day_filter дней."
                        v-model="form.mlMinPercentBuyouts"
                        class="mt-1 w-full"
                        type="number"
                        min="0"
                        :danger="!!errors.mlMinPercentBuyouts"
                        :danger-text="errors.mlMinPercentBuyouts"
                    />
                </div>
            </div>
        </div>
        <div class="vx-row mb-2 mt-4">
            <div class="vx-col w-1/2">
                <div class="mt-1">
                    <vs-input
                        label="Минимальное количество показов для объявлений старше age_day_filter дней."
                        v-model="form.mlMinCountBuyouts"
                        class="mt-1 w-full"
                        type="number"
                        min="0"
                        :danger="!!errors.mlMinCountBuyouts"
                        :danger-text="errors.mlMinCountBuyouts"
                    />
                </div>
            </div>
            <div class="vx-col w-1/2">
                <div class="mt-1">
                    <vs-input
                        label="Минимальное количество показов для объявлений младше age_day_filter дней."
                        v-model="form.mlMinBuyoutsLess7"
                        class="mt-1 w-full"
                        type="number"
                        min="0"
                        :danger="!!errors.mlMinBuyoutsLess7"
                        :danger-text="errors.mlMinBuyoutsLess7"
                    />
                </div>
            </div>
        </div>

        <div class="vx-row mb-2">
            <div class="vx-col w-1/2">
                <div class="mt-1">
                    <vs-input
                        label="Количество показов меньше которого считается средний CTR."
                        v-model="form.mlBuyoutsAvgCtr"
                        class="mt-1 w-full"
                        type="number"
                        min="0"
                        :danger="!!errors.mlBuyoutsAvgCtr"
                        :danger-text="errors.mlBuyoutsAvgCtr"
                    />
                </div>
            </div>
            <div class="vx-col w-1/2">
                <div class="mt-1">
                    <vs-input
                        label="Минимальное количество показов для интересов."
                        v-model="form.mlMinCountBuyoutsInterests"
                        class="mt-1 w-full"
                        type="number"
                        min="0"
                        :danger="!!errors.mlMinCountBuyoutsInterests"
                        :danger-text="errors.mlMinCountBuyoutsInterests"
                    />
                </div>
            </div>
        </div>

        <div class="vx-row mb-2">
            <div class="vx-col w-1/2">
                <div class="mt-1">
                    <vs-input
                        label="Минимальный процент показов для интересов."
                        v-model="form.mlMinPercentBuyoutsInterests"
                        class="mt-1 w-full"
                        type="number"
                        min="0"
                        :danger="!!errors.mlMinPercentBuyoutsInterests"
                        :danger-text="errors.mlMinPercentBuyoutsInterests"
                    />
                </div>
            </div>
            <div class="vx-col w-1/2">
                <div class="mt-1">
                    <vs-input
                        label="Минимальное количество кликов для вычисления интервала статы."
                        v-model="form.mlMinClickCountCalcInterval"
                        class="mt-1 w-full"
                        type="number"
                        min="0"
                        :danger="!!errors.mlMinClickCountCalcInterval"
                        :danger-text="errors.mlMinClickCountCalcInterval"
                    />
                </div>
            </div>
        </div>

        <div class="vx-row mb-2">
            <div class="vx-col w-1/2">
                <div class="mt-1">
                    <vs-input
                        label="Максимальное количество интересов для объявления."
                        v-model="form.mlNumberInterestsAtTop"
                        class="mt-1 w-full"
                        type="number"
                        min="0"
                        :danger="!!errors.mlNumberInterestsAtTop"
                        :danger-text="errors.mlNumberInterestsAtTop"
                    />
                </div>
            </div>
            <div class="vx-col w-1/2">
                <div class="mt-1">
                    <vs-input
                        label="Выбранные интересы для расчета (через запятую)."
                        v-model="form.mlSelectedInterests"
                        class="mt-1 w-full"
                        :danger="!!errors.mlSelectedInterests"
                        :danger-text="errors.mlSelectedInterests"
                    />
                </div>
            </div>
        </div>

        <div class="vx-row mb-2">
            <div class="vx-col w-1/2">
                <div class="mt-1">
                    <vs-input
                        label="Количество дней по умолчанию для расчета."
                        v-model="form.mlSelectedDefaultDays"
                        class="mt-1 w-full"
                        type="number"
                        min="0"
                        :danger="!!errors.mlSelectedDefaultDays"
                        :danger-text="errors.mlSelectedDefaultDays"
                    />
                </div>
            </div>
            <div class="vx-col w-1/2">
                <div class="mt-1">
                    <vs-input
                        label="Список SSP для расчета."
                        v-model="form.mlSSPIDsFilter"
                        class="mt-1 w-full"
                        :danger="!!errors.mlSSPIDsFilter"
                        :danger-text="errors.mlSSPIDsFilter"
                    />
                </div>
            </div>
        </div>

        <div class="vx-row mb-2">
            <div class="vx-col w-1/2">
                <div class="mt-1">
                    <vs-input
                        label="Лимит количества групп площадок для нормализации."
                        v-model="form.mlLimitSitesNormalization"
                        class="mt-1 w-full"
                        type="number"
                        min="0"
                        :danger="!!errors.mlLimitSitesNormalization"
                        :danger-text="errors.mlLimitSitesNormalization"
                    />
                </div>
            </div>
            <div class="vx-col w-1/2">
                <div class="mt-1">
                    <vs-input
                        label="Количество кликов меньше которого считается средний CTR."
                        v-model="form.mlClickThresholdAttributesCalc"
                        class="mt-1 w-full"
                        type="number"
                        min="0"
                        :danger="!!errors.mlClickThresholdAttributesCalc"
                        :danger-text="errors.mlClickThresholdAttributesCalc"
                    />
                </div>
            </div>
        </div>

        <div class="vx-row mb-2">
            <div class="vx-col w-1/2">
                <div class="mt-1">
                    <vs-checkbox class="mt-6" icon="check" color="rgb(38, 187, 174)" v-model="form.mlUseAttributeCoefficients">
                        Применять коеффициенты атрибутов.
                    </vs-checkbox>
                </div>
            </div>
            <div class="vx-col w-1/2">
                <div class="mt-1">
                    <vs-checkbox class="mt-6" icon="check" color="rgb(38, 187, 174)" v-model="form.mlUseAttrCoeffsTargetByGender">
                        Применять коэффициенты атрибутов таргинта по полу.
                    </vs-checkbox>
                </div>
            </div>
        </div>

        <vs-button class="mt-5 mr-2" color="success" @click="saveSettings()" type="filled"> Сохранить </vs-button>

        <vs-button class="mt-5" color="primary" @click="clearEdit()" type="filled"> Отменить </vs-button>
    </vx-card>
</template>

<script>
export default {
    data() {
        return {
            settings: undefined,
            form: {
                mlAgeDayFilter: 0,
                mlMinPercentBuyouts: 0,
                mlMinCountBuyouts: 0,
                mlMinBuyoutsLess7: 0,
                mlBuyoutsAvgCtr: 0,
                mlMinCountBuyoutsInterests: 0,
                mlMinPercentBuyoutsInterests: 0,
                mlMinClickCountCalcInterval: 0,
                mlNumberInterestsAtTop: 0,
                mlSelectedInterests: '',
                mlSelectedDefaultDays: 0,
                mlSSPIDsFilter: '',
                mlLimitSitesNormalization: 0,
                mlClickThresholdAttributesCalc: 0,
                mlUseAttributeCoefficients: false,
                mlUseAttrCoeffsTargetByGender: false
            },
            errors: {
                mlAgeDayFilter: '',
                mlMinPercentBuyouts: '',
                mlMinCountBuyouts: '',
                mlMinBuyoutsLess7: '',
                mlBuyoutsAvgCtr: '',
                mlMinCountBuyoutsInterests: '',
                mlMinPercentBuyoutsInterests: '',
                mlMinClickCountCalcInterval: '',
                mlNumberInterestsAtTop: '',
                mlSelectedInterests: '',
                mlSelectedDefaultDays: '',
                mlSSPIDsFilter: '',
                mlLimitSitesNormalization: '',
                mlClickThresholdAttributesCalc: '',
                mlUseAttributeCoefficients: '',
                mlUseAttrCoeffsTargetByGender: ''
            }
        };
    },
    mounted() {
        this.loadSettings();
    },
    methods: {
        loadSettings() {
            this.$vs.loading({
                container: '#loader',
                type: 'sound'
            });

            this.$axios({
                method: 'GET',
                url: 'settings/ml',
                success: (settings) => {
                    this.settings = settings;
                    this.setSettings(settings);

                    this.$vs.loading.close('#loader > .con-vs-loading');
                },
                catch: (err) => {
                    this.$vs.loading.close('#loader > .con-vs-loading');
                    return this.$vs.notify({
                        title: 'Внимание!',
                        text: 'Ошибка получения профиля пользователя!',
                        color: 'danger'
                    });
                }
            });
        },
        setSettings(settings) {
            this.form.mlAgeDayFilter = settings.mlAgeDayFilter;
            this.form.mlMinPercentBuyouts = settings.mlMinPercentBuyouts;
            this.form.mlMinCountBuyouts = settings.mlMinCountBuyouts;
            this.form.mlMinBuyoutsLess7 = settings.mlMinBuyoutsLess7;
            this.form.mlBuyoutsAvgCtr = settings.mlBuyoutsAvgCtr;
            this.form.mlMinCountBuyoutsInterests = settings.mlMinCountBuyoutsInterests;
            this.form.mlMinPercentBuyoutsInterests = settings.mlMinPercentBuyoutsInterests;
            this.form.mlMinClickCountCalcInterval = settings.mlMinClickCountCalcInterval;
            this.form.mlNumberInterestsAtTop = settings.mlNumberInterestsAtTop;
            this.form.mlSelectedInterests = settings.mlSelectedInterests;
            this.form.mlSelectedDefaultDays = settings.mlSelectedDefaultDays;
            this.form.mlSSPIDsFilter = settings.mlSSPIDsFilter;
            this.form.mlLimitSitesNormalization = settings.mlLimitSitesNormalization;
            this.form.mlClickThresholdAttributesCalc = settings.mlClickThresholdAttributesCalc;
            this.form.mlUseAttributeCoefficients = settings.mlUseAttributeCoefficients;
            this.form.mlUseAttrCoeffsTargetByGender = settings.mlUseAttrCoeffsTargetByGender;
        },
        clearEdit() {
            this.setSettings(this.settings);
        },
        saveSettings() {
            let error = '';
            const interests = this.form.mlSelectedInterests;
            if (!interests) {
                error = 'Необходимо указать интересы через запятую.';
            }

            let interstsParsed = [];
            const interestsParts = interests.split(',').filter((i) => i != '');
            if (interestsParts && interestsParts.length > 0) {
                interestsParts.forEach((i) => {
                    if (!Number.isInteger(Number(i))) {
                        error = 'Введен некорректный список интересов.';
                    } else {
                        interstsParsed.push(i.trim());
                    }
                });
            }

            const sspIds = this.form.mlSSPIDsFilter;
            if (!sspIds) {
                error = 'Необходимо указать SSP через запятую.';
            }

            let sspIdsParsed = [];
            const sspIdsParts = sspIds.split(',').filter((i) => i != '');
            if (sspIdsParts && sspIdsParts.length > 0) {
                sspIdsParts.forEach((i) => {
                    if (!Number.isInteger(Number(i))) {
                        error = 'Введен некорректный список SSP.';
                    } else {
                        sspIdsParsed.push(i.trim());
                    }
                });
            }

            if (error) {
                return this.$vs.notify({
                    title: 'Внимание!',
                    text: error,
                    color: 'danger'
                });
            }

            this.form.mlSelectedInterests = interstsParsed.join(',');
            this.form.mlSSPIDsFilter = sspIdsParsed.join(',');

            this.$vs.loading({
                container: '#loader',
                type: 'sound'
            });

            this.$axios({
                method: 'PUT',
                url: 'settings/ml',
                params: this.form,
                errors: this.errors,
                success: (response) => {
                    this.$vs.loading.close('#loader > .con-vs-loading');
                    this.$vs.notify({
                        title: 'Успешно обновлено',
                        text: 'Настройки успешно обновлены',
                        color: 'success'
                    });
                },
                catch: (err) => {
                    this.$vs.loading.close('#loader > .con-vs-loading');
                    return this.$vs.notify({
                        title: 'Внимание!',
                        text: 'Ошибка при сохранении настроек!',
                        color: 'danger'
                    });
                }
            });
        }
    },
    components: {}
};
</script>
